import { createGlobalStyle } from 'styled-components'
import { withTheme } from '@material-ui/styles'

const GlobalStyle = withTheme(createGlobalStyle``)

export default GlobalStyle
